import React from 'react'
import { Stamp } from './style'

export default ({ variation = 'card' }) => <Stamp variation={variation} />
